module.exports = __webpack_public_path__ + "img/168.4cda04d3.jpg";